export default "__VITE_ASSET__pxYxQmYj__"